import { render, staticRenderFns } from "./InstructionsModal.vue?vue&type=template&id=d332261c&"
import script from "./InstructionsModal.vue?vue&type=script&lang=js&"
export * from "./InstructionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports